import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'groupFilter'
})
export class GroupFilterPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    console.log(args)
    return true;
  }

}
